<template>
  <div class="home">
    <!-- Header -->
    <vue-headful
      v-if="meta"
      :title="meta.fields['Title']"
      :description="meta.fields['Description']"
      :keywords="meta.fields['Keywords']" />
    <!-- End Header -->

    <!-- Loader -->
    <vue-element-loading
      :active="!allLoaded"
      is-full-screen
      spinner="bar-fade-scale" />
    <!-- End Loader -->

    <!-- <section
      v-if="allLoaded"
      id="expertise">
      <v-container :class="`${$vuetify.breakpoint.xsOnly ? 'expertise__mobile' : 'expertise__desktop'}`">
        <v-carousel
          cycle
          :class="$vuetify.breakpoint.xsOnly ? 'expertise__mobile--carousel' : 'expertise__desktop--carousel'"
          height="500"
          hide-delimiter-background
          show-arrows-on-hover>
          <v-carousel-item
            v-for="(slide, i) in slides"
            :key="i">
            <v-sheet
              :color="colors[i]"
              height="100%">
              <v-row
                class="fill-height"
                align="center"
                justify="center">
                <div class="display-3">
                  {{ slide }} Slide
                </div>
              </v-row>
            </v-sheet>
          </v-carousel-item>
        </v-carousel>
        <v-card
          :class="`${$vuetify.breakpoint.xsOnly ? 'expertise__mobile--title' : 'expertise__desktop--title'}`"
          flat
          color="transparent">
          <v-col>
            <transition-group
              appear
              name="title-fade">
              <template v-for="(expertise, index) in homeExpertises">
                <v-card-title
                  :key="expertise.id"
                  :style="{ transitionDelay: (index/3)+'s', display: 'inline-block' }"
                  :class="`${$vuetify.breakpoint.lgAndUp ?' display-3': 'display-1'} ${index === 0 ? 'black--text font-weight-black ml-5 pa-0' : 'black white--text d-inline-block px-5 py-0 mt-1'}`">
                  {{ expertise.fields.Name }}
                </v-card-title>
                <br :key="'br'+expertise.id">
              </template>
            </transition-group>
            <v-btn
              light
              text
              to="/our-expertise"
              class="font-weight-black text-none"
              style="letter-spacing: -0.05px">
              Know Our Expertise
              <v-icon>arrow_right</v-icon>
            </v-btn>
          </v-col>
        </v-card>
      </v-container>
    </section> -->

    <!-- Home Expertise Carousel -->
    <section v-if="allLoaded"
             id="carousel">
      <v-container style="position: relative;">
        <v-card flat
                color="transparent"
                :class="$vuetify.breakpoint.xsOnly ? 'expertise_title-mobile' : 'expertise_title-desktop'">
          <transition-group appear
                            name="title-fade">
            <template v-for="(expertise, index) in homeExpertises">
              <h1 :key="expertise.id"
                  :style="{ transitionDelay: (index/3)+'s', display: 'inline-block' }"
                  :class="`${$vuetify.breakpoint.lgAndUp ?' display-3': 'display-1'} ${index === 0 ? 'black--text font-weight-black ml-5 pa-0' : 'black white--text d-inline-block px-5 py-0 mt-1'}`">
                {{ expertise.fields.Name }}
              </h1>
              <br :key="'br'+expertise.id">
            </template>
          </transition-group>
          <v-btn light
                 text
                 to="/our-expertise"
                 class="font-weight-black text-none"
                 style="letter-spacing: -0.05px">
            Know Our Expertise
            <v-icon>arrow_right</v-icon>
          </v-btn>
        </v-card>
        <v-carousel
          :class="$vuetify.breakpoint.mdAndUp ? 'expertise_image-desktop' : 'expertise_image-mobile'"
          cycle
          continuous
          :hide-delimiter-background="true"
          :hide-delimiters="true"
          :show-arrows="false">
          <v-carousel-item
            v-for="(banner, i) in banners"
            :key="i">
            <v-img :contain="true"
                   :eager="true"
                   :alt="banner.alt"
                   :src="banner.src"
                   max-height="500" />
          </v-carousel-item>
        </v-carousel>
      </v-container>
    </section>
    <!-- End Home Expertise Carousel -->

    <!-- Case Studies Carousel -->
    <section v-if="allLoaded"
             id="projects">
      <v-container class="projects__wrapper">
        <!-- And We Build Them For -->
        <span :class="$vuetify.breakpoint.lgAndUp ? 'project__titles--desktop' : ''">
          <transition-group appear
                            name="title-fade">
            <template v-for="(caseStudyTitle, index) in homeCaseStudiesTitles">
              <h1 :key="caseStudyTitle.id"
                  :to="{ name: 'work', params: { slug: caseStudyTitle.fields.Slug } }"
                  :style="{ transitionDelay: (index/3)+'s', display: 'inline-block' }"
                  :class="`${$vuetify.breakpoint.lgAndUp ?' display-3': 'display-1'} ${index === 0 || index === 1 ? 'black--text font-weight-black ml-5 pa-0' : 'black white--text d-inline-block px-5 py-0 mt-1'}`">
                {{ caseStudyTitle.fields.Name }}
              </h1>
              <br :key="'br'+caseStudyTitle.id">
            </template>
          </transition-group>
          <v-btn to="our-work"
                 text
                 light
                 class="font-weight-black text-none py-5"
                 style="letter-spacing: -0.05px;">
            See Our Case
            Studies
            <v-icon>arrow_right</v-icon>
          </v-btn>
        </span>
        <!-- End And We Build Them For -->

        <!-- Projects Scroller -->
        <v-container
          :class="$vuetify.breakpoint.lgAndUp ? 'project__carousel--desktop' : ''">
          <v-row id="project-scroller"
                 v-dragscroll
                 :class="$vuetify.breakpoint.lgAndUp ? 'scrolling__wrapper--desktop' : 'scrolling__wrapper--mobile'">
            <v-card v-for="homeCaseStudy in homeCaseStudies"
                    :key="homeCaseStudy.id"
                    class="mx-5"
                    style="flex: 0 0 auto;"
                    elevation="10"
                    max-width="250px"
                    @click="getWork(homeCaseStudy.fields.Slug)">
              <v-img v-if="(homeCaseStudy.fields.Attachments)"
                     contain
                     :eager="true"
                     :src="homeCaseStudy.fields.Attachments[0].url"
                     :title="homeCaseStudy.fields.Name"
                     :alt="homeCaseStudy.fields.Name">
                <v-card-title :class="`${$vuetify.breakpoint.lgAndUp ? 'display-1' : 'subtitle-1' } text-break white--text fill-height align-content-end`">
                  {{ homeCaseStudy.fields.Name }}
                </v-card-title>
              </v-img>
            </v-card>
          </v-row>
        </v-container>
        <!-- End Projects Scroller -->
      </v-container>
    </section>
    <!-- End Projects Carousel -->

    <!-- Partners -->
    <section v-if="allLoaded"
             id="partners">
      <v-container fluid
                   class="grey lighten-2 py-5">
        <v-row align="center"
               justify="center">
          <v-col align="center">
            <h2 :class="`${$vuetify.breakpoint.lgAndUp ? 'display-1' : 'headline' } font-weight-black my-5`">
              We Are Partners With
            </h2>
          </v-col>
        </v-row>
        <v-row align-content="center"
               justify="center">
          <v-col v-for="partner in partners"
                 :key="partner.id"
                 cols="2"
                 align-self="center"
                 align="center">
            <v-img v-if="(partner.fields.Attachments)"
                   :eager="true"
                   :src="partner.fields.Attachments[0].url"
                   max-width="130" />
          </v-col>
        </v-row>
      </v-container>
    </section>
    <!-- End Partners -->

    <!-- Clientele -->
    <section v-if="allLoaded"
             id="clientele">
      <v-container fluid
                   class="grey lighten-2 py-5">
        <v-row align="center"
               justify="center">
          <v-col align="center">
            <h2 :class="`${$vuetify.breakpoint.lgAndUp ? 'display-1' : 'headline' } font-weight-black my-5`">
              And We Have Worked With
            </h2>
          </v-col>
        </v-row>
        <v-row v-for="_clients in clients"
               :key="_clients.id"
               justify="space-between">
          <v-col />
          <v-col v-for="client in _clients"
                 :key="client.id"
                 cols="2"
                 align-self="center"
                 align="center">
            <v-img v-if="(client.fields.Attachments)"
                   :src="client.fields.Attachments[0].url"
                   aspect-ratio="1.7778"
                   contain
                   max-width="100" />
          </v-col>
          <v-col />
        </v-row>
      </v-container>
    </section>
    <!-- End Clientele -->
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import VueElementLoading from 'vue-element-loading';
import axios from "axios";
import _ from "lodash";
import qs from "qs";
import FadeIn from "../components/animation/FadeIn";

export default {
	name: "Home",

	components: {
		VueElementLoading,
		// FadeIn
	},

	data() {
		return {
			apiUrl: this.$VUE_APP_AIRTABLE_URL,
			apiKey: this.$VUE_APP_AIRTABLE_API_KEY, // Always use a read-only account token
			apiBase: this.$VUE_APP_AIRTABLE_BASE,

			homeExpertises: [],
			homeCaseStudiesTitles: [],
			homeCaseStudies: null,
			partners: null,
			clients: null,

			isGetHomeExpertisesLoading: false,
			isGetCaseStudiesTitlesLoading: false,
			isGetHomeCaseStudiesLoading: false,
			isGetPartnersLoading: false,
			isGetClientsLoading: false,

			banners: [
				{
					alt: 'Airbitat',
					src: 'img/banner-Airbitat@1x.png'
				},
				{
					alt: 'PSB Academy',
					src: 'img/banner-psb@1x.png'
				},
				{
					alt: 'Seoul Garden',
					src: 'img/banner-SG@1x.png'
				}
			],

			caseStudiesTitle: [
				{
					lgAttr: "display-2 black--text font-weight-black ma-0 pa-0",
					smAttr: "headline black--text font-weight-black ma-0 pa-0",
					words: "And We Build"
				},
				{
					lgAttr: "display-2 black--text font-weight-black ma-0 pa-0",
					smAttr: "headline black--text font-weight-black ma-0 pa-0",
					words: "Them For"
				},
				{
					lgAttr: "display-2 black d-inline-block px-3 py-0 mt-1",
					smAttr: "headline black d-inline-block px-3 py-0 mt-1",
					words: "Ad Agency"
				},
				{
					lgAttr: "display-2 black d-inline-block px-3 py-0 mt-1",
					smAttr: "headline d-inline-block black--text font-weight-black ma-0 pa-0",
					words: "Educators"
				},
				{
					lgAttr: "display-2 black d-inline-block px-3 py-0 mt-1",
					smAttr: "headline d-inline-block black--text font-weight-black ma-0 pa-0",
					words: "Restaurants"
				},
				{
					lgAttr: "display-2 black d-inline-block px-3 py-0 mt-1",
					smAttr: "headline d-inline-block black--text font-weight-black ma-0 pa-0",
					words: "Mobile Networks"
				}
			],

			colors: [
				'indigo',
				'warning',
				'pink darken-2',
				'red lighten-1',
				'deep-purple accent-4',
			],
			slides: [
				'First',
				'Second',
				'Third',
				'Fourth',
				'Fifth',
			],
		};
	},

	mounted : function() {
		this.isGetHomeExpertisesLoading,
		this.isGetCaseStudiesTitlesLoading,
		this.isGetHomeCaseStudiesLoading,
		this.isGetPartnersLoading,
		this.isGetClientsLoading = true;
		this.getHomeExpertises();
		this.getCaseStudiesTitles();
		this.getHomeCaseStudies();
		this.getPartners();
		this.getClients();
	},

	computed: {

		optionLeft () {
			return {
				hoverStop: false,
				autoPlay: true,
				limitMoveNum: 4,
				direction: 2,
			};
		},

		meta: function () {
			return this.$store.getters['meta/getMeta'](this.$route.path);
		},

		allLoaded: function () {
			if (!this.isGetHomeExpertisesLoading && !this.isGetCaseStudiesTitlesLoading && !this.isGetHomeCaseStudiesLoading && !this.isGetPartnersLoading && !this.isGetClientsLoading) {
				return true;
			}
			return false;
		},
	},

	methods: {

		fadePressed: function() {
			this.isPressed = !this.isPressed;
		},

		onTitleClick: function() {
			this.$router.push({ name: 'work', params: { slug: expertise.fields.Slug } });
		},

		getWork: function(slug) {
			this.$router.push({ path: '/work/' + slug });
		},

		getHomeExpertises: function() {
			axios({
				url: this.apiUrl + this.apiBase + "/HomeExpertise",
				headers: {
					Authorization: `Bearer ${this.apiKey}`
				}
			}).then(res => {
				this.homeExpertises = res.data.records;
			}).finally(() => {
				this.isGetHomeExpertisesLoading = false;
			});
		},

		getCaseStudiesTitles: function() {
			axios({
				url: this.apiUrl + this.apiBase + "/HomeWeBuildThemFor",
				headers: {
					Authorization: `Bearer ${this.apiKey}`
				},
				params: {
					sort: [ { field: "Order", direction: "asc" } ]
				},
				paramsSerializer: function(params) {
					return qs.stringify(params);
				}
			}).then(res => {
				this.homeCaseStudiesTitles = res.data.records;
			}).finally(() => {
				this.isGetCaseStudiesTitlesLoading = false;
			});
		},

		getHomeCaseStudies: function() {
			let numColumns = 4;
			axios({
				url: this.apiUrl + this.apiBase + "/HomeCaseStudies",
				headers: {
					Authorization: `Bearer ${this.apiKey}`
				},
				params: {
					sort: [ { field: "Sorting", direction: "asc" } ]
				},
				paramsSerializer: function(params) {
					return qs.stringify(params);
				}
			}).then(res => {
				// res.data.records.unshift({ isIntro: true });
				// this.homeCaseStudies = _.chunk(res.data.records, numColumns);

				this.homeCaseStudies = res.data.records;
			}).finally(() => {
				this.isGetHomeCaseStudiesLoading = false;
			});
		},

		getPartners: function() {
			axios({
				url: this.apiUrl + this.apiBase + "/Partners",
				headers: {
					Authorization: `Bearer ${this.apiKey}`
				},
				params: {
					sort: [ { field: "Sorting", direction: "asc" } ]
				},
				paramsSerializer: function(params) {
					return qs.stringify(params);
				}
			}).then(res => {
				this.partners = res.data.records;
			}).finally(() => {
				this.isGetPartnersLoading = false;
			});
		},

		getClients: function() {
			let numColumns = 4;
			axios({
				url: this.apiUrl + this.apiBase + "/Clients",
				headers: {
					Authorization: `Bearer ${this.apiKey}`
				},
				params: {
					sort: [ { field: "Sorting", direction: "asc" } ]
				},
				paramsSerializer: function(params) {
					return qs.stringify(params);
				}
			}).then(res => {
				this.clients = _.chunk(res.data.records, numColumns);
			}).finally(() => {
				this.isGetClientsLoading = false;
			});
		}
	}
};
</script>
<style>
#carousel {
  margin-top: 60px;
  margin-bottom: 100px;
}

#projects {
  padding-top: 100px;
  margin-top: 40px;
  margin-bottom: 100px;
}

.projects__wrapper {
  position: relative;
}

.project__titles--desktop {
  display: inline;
  position: absolute;
  background-color: transparent;
  top: 0;
  z-index: 1;
}

.project__carousel--desktop {
  position: relative;
}

/* .expertise__desktop--carousel {
  position: relative !important;
} */

/* .expertise__desktop--title {
  position: absolute !important;
  top: 50px;
} */

.scrolling__wrapper--desktop {
  cursor: e-resize;
  margin-top: 100px;
  margin-left: 400px;
  display: flex;
  flex-wrap: nowrap;
  overflow-x: scroll;
  -ms-overflow-style: none;
}

.scrolling__wrapper--desktop::-webkit-scrollbar {
  display: none;
}

.scrolling__wrapper--mobile {
  margin-top: 0;
  margin-left: 0;
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  -ms-overflow-style: none;
}

.expertise_title-desktop {
  position: relative;
  margin-left: 100px;
  z-index: 1;
}

.expertise_title-mobile {
  position: default;
  margin-left: 0px;
}

.expertise_image-desktop {
  position: absolute !important;
  min-height: 500px;
  right: 0;
  top: 0;
}

.expertise_image-mobile {
  position: default;
  height: 100%;
  width: 100%;
}

.title-fade-enter-active,
.title-fade-leave-active {
	transition: all 1s cubic-bezier(0, 0.5, 0.5, 1);
}

.title-fade-enter,
.title-fade-leave-to {
	transform: translateX(-50px);
	opacity: 0;
}
</style>
